module.exports = __webpack_public_path__ + "img/recommendation-4.1f95d74d.svg";